import { RouterSlug } from '@enums';

export const seoVariables = {
    author: 'EraOfWe',
    image: 'https://www.eraofwe.com/op/assets/images/href-thumnail.png',
};

export const SeoTitle = {
    en: {
        [RouterSlug.SEARCH]: 'Find a coffee shop near you',
        [RouterSlug.SITEMAP]: 'Best coffee shops and their location',
    },
    sv: {
        [RouterSlug.SEARCH]: 'Hitta ett café nära dig',
        [RouterSlug.SITEMAP]: 'Bästa caféerna och dess plats',
    },
};

export const SeoDescription = {
    en: {
        [RouterSlug.SEARCH]:
            'Search for coffee shop near your location. Era of We helps you to find a café or coffee shop near you.',
        [RouterSlug.SITEMAP]:
            'Find recommended coffee shops that have joined Era of We and where they are located on the following sitemap.',
    },
    sv: {
        [RouterSlug.SEARCH]:
            'Sök efter ett kafé nära din plats som samarbetar med Era of We för att skaffa billiga kaffe av hög kvalitet.',
        [RouterSlug.SITEMAP]:
            'Hitta rekommenderade kaféer som har anslutit sig till Era of We och där de finns på följande webbplatskarta.',
    },
};
